import { CopyToClipboard } from '@10xLabs/react-web/components/CopyToClipboard'
import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td, TdId, IdWrapper } from 'components/v2/Table'
import { IsActive } from 'components/Chip'
import { useLogin } from 'features/Login/hooks'
import { BusinessClientUsersActions } from 'features/BusinessClientUsers/components/BusinessClientUsersList/Actions'
import { canWrite } from 'features/Users/utils'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { BusinessClientUser } from 'gql/generated/graphql'

interface IBusinessClientUsersListProps {
  businessClientUsers: BusinessClientUser[]
  showBusinessClient?: boolean
}

export const BusinessClientUsersList = ({
  businessClientUsers,
  showBusinessClient = false
}: IBusinessClientUsersListProps): ReactElement => {
  const login = useLogin()
  const { policies } = login.accessToken
  const canSeeActions = canWrite(FEATURES.BUSINESS_CLIENT_USER, policies)

  return (
    <div>
      <TableContainer overflow>
        <Table>
          <Thead>
            <Tr>
              {canSeeActions && <Th noUppercase></Th>}
              <Th>
                <FormattedMessage id="businessClientUsers.list.id" defaultMessage="User Id" />
              </Th>
              <Th>
                <FormattedMessage id="businessClientUsers.list.status" defaultMessage="Status" />
              </Th>
              {showBusinessClient && (
                <Th>
                  <FormattedMessage id="businessClientUsers.list.businessClient" defaultMessage="Business Client" />
                </Th>
              )}
              <Th>
                <FormattedMessage id="businessClientUsers.list.businessSite" defaultMessage="Business Site" />
              </Th>
              <Th>
                <FormattedMessage id="businessClientUsers.list.name" defaultMessage="Name" />
              </Th>
              <Th>
                <FormattedMessage id="businessClientUsers.list.title" defaultMessage="Title" />
              </Th>
              <Th>
                <FormattedMessage id="businessClientUsers.list.phone" defaultMessage="Phone" />
              </Th>
              <Th>
                <FormattedMessage id="businessClientUsers.list.email" defaultMessage="Email" />
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {businessClientUsers.map((user) => {
              return (
                <Tr key={user.id}>
                  {canSeeActions && (
                    <Td>
                      <BusinessClientUsersActions businessClientUser={user} />
                    </Td>
                  )}
                  <TdId>
                    <IdWrapper>
                      {user.id.substring(0, 8).toUpperCase()}
                      <CopyToClipboard str={user.id} />
                    </IdWrapper>
                  </TdId>
                  <Td>
                    <IsActive isActive={user.isActive} />
                  </Td>
                  {showBusinessClient && <Td>{user.businessClient.name}</Td>}
                  <Td>{user.businessSite ? user.businessSite.name : '-'}</Td>
                  <Td>
                    {user.userAccount.firstName} {user.userAccount.lastName}
                  </Td>
                  <Td>{user.title}</Td>
                  <Td>{user.userAccount.phoneNumber?.number}</Td>
                  <Td>{user.userAccount.email}</Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  )
}
